import React, { useState } from 'react';
import _get from 'lodash/get';
import { BLOCKS } from '@contentful/rich-text-types';
import Mixpanel from 'utils/mixpanelService';
import RichTextReactRenderer from 'components/RichTextReactRenderer';
import { makeStyles, Box } from '@material-ui/core';
import { CourseCustomQuestions } from './CourseCustomQuestions';
import { COURSE_REFLECT_CUSTOM_QUESTION_KEY } from '../constants';
import { CourseReflectionQuestion } from './CourseReflectionQuestion';
import { downloadPdfFile } from '../utils';
import { CourseActions } from './CourseActions';

const useStyles = makeStyles({
  richText: {
    '& p, h6': {
      fontSize: props => props.fontSize,
    },
    '& h6': {
      marginBottom: 20,
    },
  },
  button: {
    marginTop: 20,
    borderRadius: 8,
  },
});

export const CourseReflection = ({
  course,
  series,
  saveAnswer,
  answers,
  isSeriesComplete,
  onSeriesComplete,
  onNext,
  fontSize,
  coursesSiteCopy,
  seriesSiteCopy,
  activeModule,
  trackingPath,
  small,
}) => {
  const [isDownloadingPdf, setIsDownloadingPdf] = useState(false);
  const classes = useStyles({ fontSize });

  const pdf = _get(series.fields, 'assets', []).find(asset =>
    _get(asset, 'fields.file.contentType').includes('pdf'),
  );

  const handleSaveAnswer = (questionWithAnswer, isAllAnswered) => {
    saveAnswer(questionWithAnswer, COURSE_REFLECT_CUSTOM_QUESTION_KEY);

    if (isAllAnswered) {
      onSeriesComplete(false, false, true);
    }
  };

  const handleCompleteReflection = e => {
    onSeriesComplete(false, false, e.target.checked);
    Mixpanel.track('Course - Reflection - Completed', {
      course: course.fields.title,
      module: activeModule.fields.name,
      path: trackingPath,
    });
  };

  const handleNext = () => {
    onNext();
  };

  const handleDownloadPdf = async () => {
    setIsDownloadingPdf(true);
    await downloadPdfFile(pdf);
    setIsDownloadingPdf(false);
    Mixpanel.track('Course - Reflection Sheet - Downloaded', {
      course: course.fields.title,
      module: activeModule.fields.name,
      path: trackingPath,
    });
  };

  const questionRenderers = {
    comment: ({ question, onAnswerChange }) => (
      <CourseReflectionQuestion
        key={question.name}
        answers={answers}
        onAnswerChange={onAnswerChange}
        question={question}
        coursesSiteCopy={coursesSiteCopy}
        small={small}
      />
    ),
  };

  const renderEmbeddedEntry = node => (
    <Box>
      <CourseActions
        pdf={pdf}
        pdfLabel={_get(coursesSiteCopy, 'pageCopy.downloadReflection')}
        handleDownloadPdf={handleDownloadPdf}
        isDownloadingPdf={isDownloadingPdf}
        seriesSiteCopy={seriesSiteCopy}
        isSeriesComplete={isSeriesComplete}
        completed={isSeriesComplete}
        handleNext={handleNext}
        onCheckboxChange={handleCompleteReflection}
        fontSize={fontSize}
        small={small}
      />
      <CourseCustomQuestions
        node={node}
        saveAnswer={handleSaveAnswer}
        answers={answers}
        questionRenderers={questionRenderers}
      />
    </Box>
  );

  return (
    <>
      <RichTextReactRenderer
        className={classes.richText}
        data={series.fields.introduction}
        options={{
          renderNode: {
            [BLOCKS.EMBEDDED_ENTRY]: renderEmbeddedEntry,
          },
        }}
      />
    </>
  );
};
